import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RiepilogoPrenotazioniSalaGiornoResponse, PrenotazioneSalaRequest, PrenotazioneSala, RicercaPrenotazioniSalaRequest, RicercaPrenotazioniSalaResponse } from '../core/core.component';
import { Http, Headers } from '@angular/http';
import { AppConstants } from '../core/app.constants';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SalaService {
    private pattern: string = "yyyy-MM-dd";

    constructor(private http: Http, private datePipe: DatePipe) { }

    salaDetailStatus: Subject<{status: String, date?: Date, stato?: PrenotazioneSala}> = new Subject();
    refreshEvent: Subject<any> = new Subject();
    refreshProspectEvent: Subject<any> = new Subject();    

    getSalaDetailStatus(): Observable<{status: String, date?: Date, stato?: PrenotazioneSala}> {
        return this.salaDetailStatus.asObservable();
    }

    openPrenotazioneSala(date: Date) {
        let data = date != null && typeof (date) != 'undefined' ? date : null;
        this.salaDetailStatus.next({ status: "prenota", date: data });
    }

    openLiberazioneSala(date: Date, statoSala: PrenotazioneSala) {
        let data = date != null && typeof (date) != 'undefined' ? date : null;
        this.salaDetailStatus.next({ status: "libera", date: data, stato: statoSala });
    }

    openModificaPrenotazioneSala(date: Date, statoSala: PrenotazioneSala) {
        let data = date != null && typeof (date) != 'undefined' ? date : null;
        this.salaDetailStatus.next({ status: "modifica", date: data, stato: statoSala });
    }

    closeSalaDetail() {
        this.salaDetailStatus.next({ status: "close" });
    }

    getRefreshProspectEvent() : Observable<string> {
        return this.refreshProspectEvent.asObservable();
    }    

    fireRefreshProspectEvent() {
        this.refreshProspectEvent.next("reload-detail");
    }

    getRefreshEvent() : Observable<string> {
        return this.refreshEvent.asObservable();
    }    

    fireRefreshEvent() {
        this.refreshEvent.next();
    }

    checkHours(filtroHr : string) 
    {
        let hr = filtroHr;
        if(hr == null || hr.trim() == "") {
            return null;
        }
        let index = hr.lastIndexOf(":");
        if(index > 0) {
            let tmp: string[] = hr.split(":");
            let hh = Number(tmp[0]);
            let mm = Number(tmp[1]);
            let m = (Math.round(mm/15) * 15) % 60;
            let h = mm > 52 ? (hh === 23 ? 0 : ++hh) : hh;         
            if(hh > 23 || mm > 59) {
                hr = null;
            } else {
                hr = ("00"+h).slice(-2)+":"+("00"+m).slice(-2);        
            }
        }
        return hr;
    }     

    riepilogoPrenotazioneSalaGiorno(srmToken: string, giorno): Observable<RiepilogoPrenotazioniSalaGiornoResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/sale/riepilogo/" + this.datePipe.transform(giorno, this.pattern);
        url = AppConstants.urlForNoCache(url);

        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }

    prenotaSala(srmToken: string, data: PrenotazioneSalaRequest) {
        var url = environment.REST_SERVICE_BASE_URL + "/sale/prenota";
        url = AppConstants.urlForNoCache(url);

        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.post(url, data, { headers: headers }).map((responseData) => responseData.json());
    }

    modificaPrenotazione(srmToken: string, data: PrenotazioneSalaRequest, idPrenotazione: number) {
        var url = environment.REST_SERVICE_BASE_URL + "/sale/modifica/" + idPrenotazione;
        url = AppConstants.urlForNoCache(url);

        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.post(url, data, { headers: headers }).map((responseData) => responseData.json());
    }

    liberaSala(srmToken: string, idPrenotazione: number) {
        var url = environment.REST_SERVICE_BASE_URL + "/sale/cancella/" + idPrenotazione;
        url = AppConstants.urlForNoCache(url);

        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

    ricercaPrenotazioni(srmToken: string, request: RicercaPrenotazioniSalaRequest): Observable<RicercaPrenotazioniSalaResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/sale/ricerca";
        url = AppConstants.urlForNoCache(url);

        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.post(url, request, { headers: headers }).map((responseData) => responseData.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/service/sala.service.ts